export default "__VITE_ASSET__Qs0EcA$4__"